module.exports = __webpack_public_path__ + "img/verified-visa.fb0dbb4d.svg";